import React, { useState, useEffect, useRef } from "react"
import Svg from "../_svgs/svg"
import * as date from "../../booking/helpers/date"
import { ItineraryContentBlockNoInformation } from "./ItineraryContentBlockNoInformation"
import { ItineraryContentBlockDoubleImage } from "./ItineraryContentBlockDoubleImage"
import { ItineraryContentBlockSingleImage } from "./ItineraryContentBlockSingleImage"
import { ItineraryContentBlockServiceNotice } from "./ItineraryContentBlockServiceNotice"
import { ItineraryContentBlockHeadlineButton } from "./ItineraryContentBlockHeadlineButton"
import { ItineraryContentBlockCarousel } from "./ItineraryContentBlockCarousel"
import { ItineraryUspContainer } from "./ItineraryUspContainer"
import { ItineraryArrivalDeparture } from "./ItineraryArrivalDeparture"
import { ItineraryBoarding } from "./ItineraryBoarding"
import { ItinerarySecurity } from "./ItinerarySecurity"
import { ItineraryPassport } from "./ItineraryPassport"
import { ItineraryCheckIn } from "./ItineraryCheckIn"
import { ItinerarySection } from "./ItinerarySection"
import { ItineraryCriticalInformation } from "./ItineraryCriticalInformation"
import { ItineraryParking } from "./ItineraryParking"
import { ItineraryTaxfree } from "./ItineraryTaxfree"
import { ItineraryArrivalAtAirport } from "./ItineraryArrivalAtAirport"
import { UspBannerBlock } from "./UspBannerBlock"
import { ItineraryTravelInformation } from "./ItineraryTravelInformation"
import { ItineraryEssentialInfo } from "./ItineraryEssentialInfo"
import { ItineraryBaggage } from "./ItineraryBaggage"
import { ItineraryObsBlock } from "./ItineraryObsBlock"
import { ItineraryDepartureList } from "./ItineraryDepartureList"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import { hosts } from "./itinerary-module"
import * as cookieNames from "../../booking/constants/Cookies"
import * as cookieHelper from "../../helpers/cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import reactStringReplace from "react-string-replace"
import * as TravelTypes from "./TravelTypes"
import { isMobile } from "react-device-detect"
import { DateTime } from "luxon"
import { trackTravelPlanner } from "../../helpers/tracking"
import MerchantInfoModal from "../modal/merchant-info-modal"
import FlightSignupModal from "../modal/flight-signup-modal"
import { handleEvalTracking } from "../../helpers/tracking"
import { useStore } from "../store/commonStore"

export function ItineraryComponent(props) {
  const {
    flightInfo: propsFlightInfo,
    time,
    terminalLabel,
    gateLabel,
    statusLabel,
    changeLinkString,
    flightIdLink,
    currentPage,
    finger,
    gate,
    airlinesPageLink,
    gateCloses,
    checkInOpens,
    boardingOpens,
    travelGuideLink,
    travelInformation: propsTravelInformation,
    airlineHeroImage,
    showFlightInfoBackgroundBox,
    updatedLabel,
    marketingConsent,
    profile: propsProfile,
  } = props
  const { flightSignUpModalOpen, setFlightSignUpModalOpen } = useStore()
  const [profile, setProfile] = useState(propsProfile)
  const [flightInfo, setFlightInfo] = useState(propsFlightInfo)
  const [travelInformation, setTravelInformation] = useState(propsTravelInformation)
  const [parkingStructureDataAltitude, setParkingStructureDataAltitude] = useState(undefined)
  const [parkingStructureDataCrm, setParkingStructureDataCrm] = useState(undefined)
  const [parkingStructureDataCrmIdp, setParkingStructureDataCrmIdp] = useState(undefined)
  const [followFlight, setFollowFlight] = useState(false)
  const [statusClass, setStatusClass] = useState("")
  const [publicRemark, setPublicRemark] = useState("")
  const [tabToggle, setTabToggle] = useState(flightInfo.Direction === "D" ? TravelTypes.DEPARTURE : TravelTypes.ARRIVAL)
  const [earlierStepsOpen, setEarlierStepsOpen] = useState(false)
  const [updatedTime, setUpdatedTime] = useState(DateTime.now())
  const [isMerchantModalShown, setIsMerchantModalShown] = useState(false)
  const [merchantModalData, setMerchantModalData] = useState({})
  const [tabOneActiveSteps, setTabOneActiveSteps] = useState([])
  const [tabOneInactiveSteps, setTabOneInactiveSteps] = useState([])
  const [tabTwoActiveSteps, setTabTwoActiveSteps] = useState([])
  const [tabTwoInactiveSteps, setTabTwoInactiveSteps] = useState([])
  const [trackingEventLabel, setTrackingEventLabel] = useState("")

  const cancelledRef = useRef(null)

  const isLoggedIn = !!profile

  const awaitingClosedLabel = flightInfo?.PublicRollOff === "1" ? currentPage?.closedLabel || "Closed" : currentPage?.awaitingLabel || "Afventer"

  useEffect(() => {
    let followFlightCookie = cookieHelper.getCookie(cookieNames.CPH_FOLLOW_FLIGHT)
    if (followFlightCookie) {
      const flightFollowed = followFlightCookie.filter((f) => f.id === flightInfo.FlightId).length > 0
      setFollowFlight(flightFollowed)
    }

    const destinationHeader = document.getElementsByClassName("destination-header__text")[0]
    const topOffset = destinationHeader && destinationHeader.getBoundingClientRect().top + window.scrollY

    const hash = window.location.hash
    if (hash) {
      if (hash === "#cancelled") {
        cancelledRef.current.scrollIntoView({
          behavior: "smooth",
        })
      }
    }

    if (profile && isLoggedIn) {
      setLoginState()
    }

    setSteps()
    addEventListeners()
    initiateAutomaticFlightInfoUpdate()
  }, [])

  useEffect(() => {
    if (profile !== profile) {
      setProfile(profile)
      setLoginState()
    }
    addEventListeners()
  }, [profile])

  const initiateAutomaticFlightInfoUpdate = () => {
    const now = new Date()
    const seconds = now.getSeconds()
    const msTimeout = (60 - seconds) * 1000
    setTimeout(() => {
      updateFlightInfoAndSteps()
      setInterval(() => {
        updateFlightInfoAndSteps()
      }, 60000)
    }, msTimeout)
  }

  const addEventListeners = () => {
    const anchorLinks = document.querySelectorAll('a[href="#timatic-anchor"]')
    const accordion = document.querySelector("#timatic-anchor")
    if (accordion) {
      const accordionHeadline = accordion.querySelector("h5")
      if (anchorLinks.length > 0 && accordionHeadline) {
        anchorLinks.forEach((element) => {
          element.addEventListener("click", () => {
            if (!accordion.classList.contains("open")) {
              eventFire(accordionHeadline, "click")
            }
          })
        })
      }
    }

    const followFlightInput = document.getElementById("followFlight")
    if (followFlightInput) {
      followFlightInput.addEventListener("change", (e) => {
        if (e.target) {
          let slider = document.getElementsByClassName("followFlightReact")
          if (slider && slider[0].dataset.enableFollowFlight === "true") {
            if (e.target.checked) {
              setFollowFlight(true)
              showSignupModal("toggle")
            } else {
              setFollowFlight(false)
            }
          }
        }
      })
    }
  }

  const showMerchantInfoModal = (MerchantSlideObject) => {
    if (Object.keys(MerchantSlideObject).length === 0) {
      setIsMerchantModalShown((prevState) => !prevState)
      return
    }
    setMerchantModalData(MerchantSlideObject)
    setIsMerchantModalShown((prevState) => !prevState)

    if (isMerchantModalShown) {
      document.body.classList.add("body-lock-scroll")
    } else {
      document.body.classList.remove("body-lock-scroll")
    }
  }

  const updateFlightInfoAndSteps = async () => {
    const response = await axios.get(endpoint.FLIGHT_INFO_SOLR(hosts, flightInfo.language, flightInfo.RecordId))
    if (response && response.data) {
      const flight = JSON.parse(response.data)
      const now = DateTime.now()
      setFlightInfo(flight)
      setStatusClass(flight.statusClass)
      setPublicRemark(flight.status)
      setUpdatedTime(now)
      setSteps()
    }
  }

  const setSteps = () => {
    let tabOneActiveSteps = []
    let tabOneInactiveSteps = []
    let tabTwoActiveSteps = []
    let tabTwoInactiveSteps = []
    if (flightInfo.Direction === "D") {
      tabOneActiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaDeparture, false))
      tabOneInactiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaDeparture, true))
      tabTwoActiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaDepartureTransferTab, false))
      tabTwoInactiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaDepartureTransferTab, true))
    } else {
      tabOneActiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaArrival, false))
      tabOneInactiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaArrival, true))
      tabTwoActiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaArrivalPickupTab, false))
      tabTwoInactiveSteps = removeEmptiesFromArray(getContentSections(currentPage.itineraryContentAreaArrivalPickupTab, true))
    }
    setTabOneActiveSteps(tabOneActiveSteps)
    setTabOneInactiveSteps(tabOneInactiveSteps)
    setTabTwoActiveSteps(tabTwoActiveSteps)
    setTabTwoInactiveSteps(tabTwoInactiveSteps)
  }

  const setLoginState = () => {
    const cookieToken = cookieHelper.getCookie(cookieNames.ACCESS_TOKEN)
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        setTravelInformation(undefined)
      }
    } else if (
      cookieToken !== currentToken ||
      !travelInformation ||
      !parkingStructureDataAltitude ||
      !parkingStructureDataCrm ||
      !parkingStructureDataCrmIdp
    ) {
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      getTravelInformation()
    }
  }

  const getTravelInformation = () => {
    var getParams = {
      flightDisplayName: flightInfo.Flight,
      direction: flightInfo.Direction,
      scheduledDate: flightInfo.ScheduledTime,
    }
    axios
      .get(endpoint.GET_TRAVEL_INFORMATION(hosts), { params: getParams })
      .then((res) => res.data)
      .then(
        (result) => {
          setTravelInformation(result)
        },
        (error) => {
          setTravelInformation(undefined)
        },
      )
  }

  const getParkingStructureDataAltitude = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_ALTITUDE(hosts, flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          setParkingStructureDataAltitude(result)
        },
        (error) => {
          setParkingStructureDataAltitude(undefined)
        },
      )
  }

  const getParkingStructureDataCrm = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_CRM(hosts, flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          setParkingStructureDataCrm(result)
        },
        (error) => {
          setParkingStructureDataCrm(undefined)
        },
      )
  }

  const getParkingStructureDataCrmIdp = () => {
    axios
      .get(endpoint.MOST_BOOKED_STRUCTURE_CRM_IDP(hosts, flightInfo.language))
      .then((res) => res.data)
      .then(
        (result) => {
          setParkingStructureDataCrmIdp(result)
        },
        (error) => {
          setParkingStructureDataCrmIdp(undefined)
        },
      )
  }

  const renderFlightInfoBottomBlock = (contentArea) => {
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "FlightInfoBottomBlock": {
              const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(block.buttonIcon)
              return (
                <React.Fragment key={i}>
                  <div className="departure-info__essentials__bottom">
                    <h5>{block.text}</h5>
                    <div>
                      <a
                        className="button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default"
                        href={block.linkToAirport ? changeLinkString : flightIdLink}
                        onClick={() => handleEvalTracking(block.buttonTracking)}
                      >
                        {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                        <span className="text">{block.buttonText}</span>
                      </a>
                    </div>
                  </div>
                </React.Fragment>
              )
            }
          }
        })
      : null
  }

  const renderItineraryInfoBlocks = (contentArea) => {
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "UspBannerBlock":
              return <UspBannerBlock key={i} showHideContent={showHideContent} block={block} />
            case "ItineraryCriticalInformation":
              return <ItineraryCriticalInformation key={i} block={block} />
            case "ItineraryEssentialInfo":
              return (
                <ItineraryEssentialInfo
                  key={i}
                  currentPageJson={currentPage} // was {...this.state}
                  block={block}
                  showHideContent={showHideContent}
                />
              )
            case "ItineraryTravelInformationBlock":
              return (
                <ItineraryTravelInformation
                  key={i}
                  currentPageJson={currentPage} // was {...this.state}
                  block={block}
                  showHideContent={showHideContent}
                  setDataToState={setDataToState}
                />
              )
          }
        })
      : null
  }

  const getSelectionCondition = (choice, blockCondition) => {
    return (
      (choice === undefined && (blockCondition === undefined || blockCondition === "" || blockCondition === "default")) || choice === blockCondition
    )
  }

  const exactSelectionCondition = (choice, blockCondition) => {
    return blockCondition === undefined || blockCondition === "" || blockCondition === "default" || choice === blockCondition
  }

  const getBlockToRender = (travelInformation, blocks) => {
    let defaultBlock = undefined
    let bestCriteriaMatchCount = 0

    let hasLuggage = travelInformation.twl ?? undefined
    let hasKids = travelInformation.twc ?? undefined
    let transportForm = travelInformation.tf ?? undefined

    for (let i = 0; i < blocks.length; i++) {
      let block = blocks[i]
      let blockHasLuggage = SelectionFactoryHelper.getFromSelectionFactory(block.checkingInBaggage)
      blockHasLuggage = blockHasLuggage === "true" ? true : blockHasLuggage === "false" ? false : blockHasLuggage
      let blockHasKids = SelectionFactoryHelper.getFromSelectionFactory(block.travelingWithKids)
      blockHasKids = blockHasKids === "true" ? true : blockHasKids === "false" ? false : blockHasKids
      let blockTransportForm = SelectionFactoryHelper.getFromSelectionFactory(block.transportToAirport)
      blockTransportForm = blockTransportForm === "true" ? true : blockTransportForm === "false" ? false : blockTransportForm

      if (blockTransportForm === "Private car (or motorcycle scooter)") {
        blockTransportForm = "Private car (or motorcycle, scooter)"
      }

      if (!exactSelectionCondition(hasLuggage, blockHasLuggage)) {
        continue
      }
      if (!exactSelectionCondition(hasKids, blockHasKids)) {
        continue
      }
      if (!exactSelectionCondition(transportForm, blockTransportForm)) {
        continue
      }

      let luggageCondition = getSelectionCondition(hasLuggage, blockHasLuggage)
      let kidsCondition = getSelectionCondition(hasKids, blockHasKids)
      let transportCondition = getSelectionCondition(transportForm, blockTransportForm)

      let criteriaMatchCount = luggageCondition + kidsCondition + transportCondition
      if (criteriaMatchCount > bestCriteriaMatchCount) {
        bestCriteriaMatchCount = criteriaMatchCount
        defaultBlock = block
      }

      if (luggageCondition && kidsCondition && transportCondition) {
        defaultBlock = block
        break
      }

      if (!defaultBlock && blockHasKids === "default" && blockHasLuggage === "default" && blockTransportForm === "default") {
        defaultBlock = block
      }
    }

    return defaultBlock
  }

  const getContentSections = (contentArea, renderInactive = false) => {
    let sections = []

    const dtLocale = date.luxonLocale(flightInfo.language)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const estimatedPublicTime = DateTime.fromISO(flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)

    if (flightInfo.Direction === "D") {
      const checkInTime = estimatedPublicTime.minus({ minutes: checkInOpens })
      const checkInActive = checkInTime <= currentTime

      const boardingTime = estimatedPublicTime.minus({ minutes: boardingOpens })
      const boardingActive = boardingTime <= currentTime

      const arrDepActive = estimatedPublicTime <= currentTime

      let beforeCheckInSection = true
      let beforeBoardingSection = true
      let beforeArrDepSection = true

      let condition = true
      let render = ""

      let groups = contentArea ? groupBy(contentArea) : null

      sections = groups
        ? groups.map((blocks, i) => {
            let inactive = false

            let block = getBlockToRender(travelInformation, blocks)
            if (!block) {
              return
            }
            switch (block.__type__) {
              case "ItinerarySectionBlock":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySection
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockArrivalAtAirport":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalAtAirport
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockParking":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = ((inactive && renderInactive) || (!inactive && !renderInactive)) && isLoggedIn
                render = condition ? (
                  <ItineraryParking
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockCheckIn":
                beforeCheckInSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryCheckIn
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                    awaitingClosedLabel={awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    checkInOpens={checkInOpens}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockSecurity":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySecurity
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    gate={gate}
                    airlinesPageLink={airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockTaxfree":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = ((inactive && renderInactive) || (!inactive && !renderInactive)) && isLoggedIn
                render = condition ? (
                  <ItineraryTaxfree
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockPassport":
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryPassport
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    gate={gate}
                    airlinesPageLink={airlinesPageLink}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockBoarding":
                beforeBoardingSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryBoarding
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                    awaitingClosedLabel={awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    gate={gate}
                    boardingOpens={boardingOpens}
                    gateCloses={gateCloses}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockArrivalDeparture":
                beforeArrDepSection = false
                inactive =
                  (beforeCheckInSection && checkInActive) ||
                  flightInfo.Cancelled ||
                  (beforeBoardingSection && boardingActive) ||
                  (beforeArrDepSection && arrDepActive) ||
                  estimatedPublicTime < currentTime
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalDeparture
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                    awaitingClosedLabel={awaitingClosedLabel}
                    checkInActive={checkInActive}
                    boardingActive={boardingActive}
                    arrDepActive={arrDepActive}
                    beforeCheckInSection={beforeCheckInSection}
                    beforeBoardingSection={beforeBoardingSection}
                    beforeArrDepSection={beforeArrDepSection}
                    hidePastSteps={currentPage.hidePastSteps}
                  />
                ) : (
                  ""
                )
                break
              default:
                render = ""
                break
            }
            return render
          })
        : null

      return sections
    } else {
      const lastBag = DateTime.fromISO(flightInfo.LastBag).setLocale(dtLocale).setZone(zone)
      const baggageTime = lastBag.plus({ days: 1 })
      const baggageOver = flightInfo.PublicRollOff === "1" || baggageTime <= currentTime
      let beforeBaggage = true

      let condition = true
      let render = ""

      let groups = contentArea ? groupBy(contentArea) : null

      sections = groups
        ? groups.map((blocks, i) => {
            let inactive = false

            let block = getBlockToRender(travelInformation, blocks)
            if (!block) {
              return
            }

            switch (block.__type__) {
              case "ItineraryContentBlockArrivalDeparture":
                inactive = publicRemark === "Landed" || flightInfo.Cancelled || publicRemark === "Baggage" || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryArrivalDeparture
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    showSignupModal={showSignupModal}
                    block={block}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                    awaitingClosedLabel={awaitingClosedLabel}
                  />
                ) : (
                  ""
                )
                break
              case "ItinerarySectionBlock":
                inactive = flightInfo.Cancelled || (beforeBaggage === true && publicRemark === "Baggage") || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItinerarySection
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    showMerchantInfoModal={showMerchantInfoModal}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    block={block}
                    showSignupModal={showSignupModal}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockBaggage":
                inactive = flightInfo.Cancelled || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                beforeBaggage = false
                render = condition ? (
                  <ItineraryBaggage
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    block={block}
                    showSignupModal={showSignupModal}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockSecurity":
                inactive = flightInfo.Cancelled || baggageOver === true
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryPassport
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    block={block}
                    showSignupModal={showSignupModal}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              case "ItineraryContentBlockDepartureList":
                inactive = flightInfo.Cancelled
                condition = (inactive && renderInactive) || (!inactive && !renderInactive)
                render = condition ? (
                  <ItineraryDepartureList
                    key={i}
                    currentPageJson={currentPage} // was {...this.state}
                    renderContentBlocks={renderContentBlocks}
                    showHideContent={showHideContent}
                    block={block}
                    showSignupModal={showSignupModal}
                    flightInfo={flightInfo}
                    airlinesPageLink={airlinesPageLink}
                  />
                ) : (
                  ""
                )
                break
              default:
                render = ""
                break
            }
            return render
          })
        : null
      return sections
    }
  }

  const renderContentBlocks = (contentArea, showNoInformationBox = true) => {
    const dtLocale = date.luxonLocale(flightInfo.language)
    const zone = "Europe/Copenhagen"
    const estimatedPublicTime = DateTime.fromISO(flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
    return contentArea
      ? contentArea.map((block, i) => {
          switch (block.__type__) {
            case "ItineraryContentBlockHeadlineButton":
              return <ItineraryContentBlockHeadlineButton key={i} block={block} showSignupModal={showSignupModal} />
            case "ItineraryContentBlockSingleImage":
              return (
                <ItineraryContentBlockSingleImage
                  key={i}
                  block={block}
                  flightInfo={flightInfo}
                  showSignupModal={showSignupModal}
                  tabToggle={tabToggle}
                />
              )
            case "ItineraryContentBlockDoubleImage":
              return <ItineraryContentBlockDoubleImage key={i} block={block} showSignupModal={showSignupModal} />
            case "ItineraryContentBlockNoInformation":
              return showNoInformationBox ? <ItineraryContentBlockNoInformation key={i} block={block} showSignupModal={showSignupModal} /> : ""
            case "ItineraryObsBlock":
              return <ItineraryObsBlock key={i} block={block} showSignupModal={showSignupModal} showHideContent={showHideContent} />
            case "ItineraryUspContainerBlock":
              return <ItineraryUspContainer key={i} block={block} />
            case "ItineraryContentBlockCarousel":
              return (
                <ItineraryContentBlockCarousel
                  key={i}
                  language={flightInfo.language}
                  showMerchantInfoModal={showMerchantInfoModal}
                  block={block}
                  flightInfo={flightInfo}
                  tabToggle={tabToggle}
                  estimatedPublicTime={estimatedPublicTime}
                />
              )
            case "ItineraryContentBlockServiceNotice":
              return (
                <ItineraryContentBlockServiceNotice
                  key={i}
                  block={block}
                  flightInfo={flightInfo}
                  showSignupModal={showSignupModal}
                  tabToggle={tabToggle}
                />
              )
            default:
              return null
          }
        })
      : null
  }

  const showHideContent = (event, classname, steps = false) => {
    const sel = getSelection().toString()
    if (!sel) {
      let elem = event.currentTarget.parentElement
      elem.__toggle = !elem.__toggle
      let target = elem.querySelector(classname)
      let parentAccordion = elem.closest(classname)
      if (elem.__toggle) {
        target.style.height = target.scrollHeight + "px"
        elem.classList.add("open")
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const combinedHeight = parentHeight + target.scrollHeight
          parentAccordion.style.height = combinedHeight + "px"
        }
      } else {
        if (parentAccordion) {
          const parentHeight = parentAccordion.offsetHeight
          const reducedHeight = parentHeight - target.scrollHeight
          parentAccordion.style.height = reducedHeight + "px"
        }
        target.style.height = 0 + "px"
        elem.classList.remove("open")
      }
      if (steps) {
        setEarlierStepsOpen((prevState) => !prevState)
        if (earlierStepsOpen) {
          trackTravelPlanner("track-event.generic", "previous steps - expand", "", flightInfo.FlightId)
        } else {
          trackTravelPlanner("track-event.generic", "previous steps - collapse", "", flightInfo.FlightId)
        }
      }
    }
  }

  const tabToggleHandler = (type) => {
    setTabToggle(type)
    setEarlierStepsOpen(false)
    handleTabChangeTracking(type)
    setSteps()
    let foldables = document.querySelectorAll(".foldable")
    if (foldables && foldables.length > 0) {
      foldables.forEach((element) => {
        let contentWrapper = element.querySelector(".contentWrapper")
        if (contentWrapper) {
          contentWrapper.style.height = null
        }
        element.__toggle = false
        element.classList.remove("open")
      })
    }
  }

  const removeEmptiesFromArray = (array) => {
    if (array && array.length > 0) {
      return array.filter((e) => {
        return e
      })
    }
    return array
  }

  const showSignupModal = (trackingEventLabel = "") => {
    setTrackingEventLabel(trackingEventLabel)
    setFlightSignUpModalOpen(true)
  }

  const setDataToState = (data, updateSteps = false) => {
    setFlightInfo(data)
    if (updateSteps) {
      setSteps()
    }
  }

  const groupBy = (array) => {
    let group = []
    let currentType = undefined
    let currentGroup = undefined
    for (var i = 0; i < array.length; i++) {
      if (currentType !== array[i].__type__) {
        if (currentGroup) {
          group.push(currentGroup)
        }
        currentType = array[i].__type__
        currentGroup = [array[i]]
      } else {
        currentGroup.push(array[i])
      }
    }
    if (currentGroup) {
      group.push(currentGroup)
    }
    return group
  }

  const eventFire = (el, etype) => {
    if (el.fireEvent) {
      el.fireEvent("on" + etype)
    } else {
      var evObj = document.createEvent("Events")
      evObj.initEvent(etype, true, false)
      el.dispatchEvent(evObj)
    }
  }

  const handleTabChangeTracking = (type) => {
    switch (type) {
      case TravelTypes.DEPARTURE:
        trackTravelPlanner("track-event.generic", "tab click", "departure", flightInfo.FlightId)
        break
      case TravelTypes.ARRIVAL:
        trackTravelPlanner("track-event.generic", "tab click", "arrival", flightInfo.FlightId)
        break
      case TravelTypes.TRANSFER:
        trackTravelPlanner("track-event.generic", "tab click", "transfer", flightInfo.FlightId)
        break
      case TravelTypes.PICKUP:
        trackTravelPlanner("track-event.generic", "tab click", "pick-up", flightInfo.FlightId)
        break
      default:
        break
    }
  }

  const tabOne = flightInfo.Direction === "D" ? TravelTypes.DEPARTURE : TravelTypes.ARRIVAL
  const tabOneLabel = flightInfo.Direction === "D" ? currentPage.destinationTabLabel || "Destination" : currentPage.arrivalTabLabel || "Ankomst"
  const tabTwo = flightInfo.Direction === "D" ? TravelTypes.TRANSFER : TravelTypes.PICKUP
  const tabTwoLabel = flightInfo.Direction === "D" ? currentPage.transferTabLabel || "Transfer" : currentPage.pickupTabLabel || "Afhent"

  let inactiveSteps = []
  let activeSteps = []
  if (tabToggle === tabOne) {
    activeSteps = tabOneActiveSteps
    inactiveSteps = tabOneInactiveSteps
  } else {
    activeSteps = tabTwoActiveSteps
    inactiveSteps = tabTwoInactiveSteps
  }
  if (tabToggle === TravelTypes.TRANSFER || tabToggle === TravelTypes.PICKUP) {
    activeSteps = inactiveSteps.concat(activeSteps)
    inactiveSteps = []
  }

  const dtLocale = date.luxonLocale(flightInfo.language)
  const zone = "Europe/Copenhagen"
  const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
  const estimatedPublicTime = DateTime.fromISO(flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
  const scheduledTime = DateTime.fromISO(flightInfo.ScheduledTime).setLocale(dtLocale).setZone(zone)

  let enableFollowFlight =
    (flightInfo.Direction === "A" && currentPage.enableFollowFlightArrivals) || (flightInfo.Direction === "D" && currentPage.enableFollowFlight)
  enableFollowFlight = tabToggle === TravelTypes.TRANSFER ? false : enableFollowFlight
  enableFollowFlight = currentTime < estimatedPublicTime ? enableFollowFlight : false
  const signUpLabel = currentPage.signUpHereFlightinformation || "Skal vi sende dig opdateringer om din afrejse? {Tilmeld din afgang her}"
  let flightinformationSignupLink = reactStringReplace(signUpLabel, /\{([^}]+)\}/g, (match, i) => (
    <a
      key={i}
      className={"pointer"}
      onClick={() => {
        showSignupModal("toggle")
        trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", flightInfo.FlightId)
      }}
    >
      {match.replace(/\{|\}/gi, "")}
    </a>
  ))
  flightinformationSignupLink = enableFollowFlight ? flightinformationSignupLink : ""

  const {
    flightInfoBottomContentAreaDeparture,
    itineraryInfoContentAreaDeparture,
    itineraryTravelInformationContentAreaDeparture,
    flightInfoBottomContentAreaArrival,
    itineraryInfoContentAreaArrival,
    itineraryTravelInformationContentAreaArrival,
  } = currentPage

  let noHeaderBottomMargin = false
  if (flightInfo.Direction === "D") {
    noHeaderBottomMargin =
      (!flightInfoBottomContentAreaDeparture || (flightInfoBottomContentAreaDeparture && flightInfoBottomContentAreaDeparture.length === 0)) &&
      (!itineraryInfoContentAreaDeparture || (itineraryInfoContentAreaDeparture && itineraryInfoContentAreaDeparture.length === 0)) &&
      (!itineraryTravelInformationContentAreaDeparture ||
        (itineraryTravelInformationContentAreaDeparture && itineraryTravelInformationContentAreaDeparture.length === 0)) &&
      !((tabTwoActiveSteps && tabTwoActiveSteps.length > 0) || (tabTwoInactiveSteps && tabTwoInactiveSteps.length > 0))
  } else {
    noHeaderBottomMargin =
      (!flightInfoBottomContentAreaArrival || (flightInfoBottomContentAreaArrival && flightInfoBottomContentAreaArrival.length === 0)) &&
      (!itineraryInfoContentAreaArrival || (itineraryInfoContentAreaArrival && itineraryInfoContentAreaArrival.length === 0)) &&
      (!itineraryTravelInformationContentAreaArrival ||
        (itineraryTravelInformationContentAreaArrival && itineraryTravelInformationContentAreaArrival.length === 0)) &&
      !((tabTwoActiveSteps && tabTwoActiveSteps.length > 0) || (tabTwoInactiveSteps && tabTwoInactiveSteps.length > 0))
  }

  const hideImage = isMobile ? currentPage.hideAirlineImageMobile : currentPage.hideAirlineImage

  const updatedTimeFormatted = updatedTime.setLocale(dtLocale).setZone(zone).toFormat("dd.MM.yyyy, HH:mm")

  return (
    <React.Fragment>
      {isMerchantModalShown ? (
        <MerchantInfoModal
          clickTracking={merchantModalData.clickTracking}
          tabToggle={merchantModalData.tabToggle}
          link={merchantModalData.link}
          name={merchantModalData.name}
          img={merchantModalData.img}
          categories={merchantModalData.categories}
          merchantDescription={merchantModalData.merchantDescription}
          merchantEmail={merchantModalData.merchantEmail}
          merchantNumber={merchantModalData.merchantNumber}
          merchantPhone={merchantModalData.merchantPhone}
          websiteAdress={merchantModalData.websiteAdress}
          supportsClickAndCollect={merchantModalData.supportsClickAndCollect}
          supportsHomeDelivery={merchantModalData.supportsHomeDelivery}
          homeDeliveryLabel={merchantModalData.homeDeliveryLabel}
          flightGate={flightInfo.Gate}
          merchantIsNearGate={merchantModalData.merchantIsNearGate}
          sameMerchants={merchantModalData.sameMerchants}
          nearGateSplashLabel={merchantModalData.nearGateSplashLabel}
          emailCoverLabel={merchantModalData.emailCoverLabel}
          alwaysOpen={merchantModalData.alwaysOpen}
          alwaysOpenLabel={merchantModalData.alwaysOpenLabel}
          estimatedPublicTime={merchantModalData.estimatedPublicTime}
          readMoreLabel={merchantModalData.readMoreLabel}
          readLessLabel={merchantModalData.readLessLabel}
          findAllLabel={merchantModalData.findAllLabel}
          clickAndCollectLabel={merchantModalData.clickAndCollectLabel}
          shopLocation={merchantModalData.shopLocation}
          showMerchantInfoModal={showMerchantInfoModal}
          isMerchantModalShown={isMerchantModalShown || false}
          lang={flightInfo.language}
          openingHours={merchantModalData.openingHours}
          openLabel={merchantModalData.openLabel}
          openingLabel={merchantModalData.openingLabel}
          closedLabel={merchantModalData.closedLabel}
          closingLabel={merchantModalData.closingLabel}
          weekdays={merchantModalData.weekdays}
          isFlightDateOlderThanToday={merchantModalData.isFlightDateOlderThanToday}
          googleMapsLink={merchantModalData.googleMapsLink}
          googleMapsLinkLabel={merchantModalData.googleMapsLinkLabel}
          googleMapsLinkTarget={merchantModalData.googleMapsLinkTarget}
        />
      ) : null}
      <div className="heroimg">
        {!hideImage && airlineHeroImage ? <img loading="eager" fetchPriority="high" src={airlineHeroImage} /> : ""}
        <div className="heroimg__text-placeholder">
          <div className="destination-header__text__left">
            <div className={showFlightInfoBackgroundBox === "True" ? "w-background" : ""}>
              <Svg iconName={"planesingle"} fillColor={"#061143"} />
              <h6>
                <span>{flightInfo.Flight}</span> - {flightInfo.DestinationName}
              </h6>
              <br />
              <h1>{flightInfo.DestinationName?.split("-")[0]}</h1>
              {publicRemark ? (
                <span className="gateinfo-placeholder">
                  <div className={`gateinfo ${statusClass}`}>{publicRemark}</div>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="w--wider">
        <div className="showondesktop">
          <div className="flight-info-update">
            <span className="label">{`${updatedLabel || "Opdateret:"} `}</span>
            <span className="time">{updatedTimeFormatted}</span>
          </div>
        </div>
        <div ref={cancelledRef} id="itineraryTop" className="panel-simple panel-simple--departure departure-info">
          <div className="departure-info__essentials">
            <div className="departure-info__essentials__top">
              <header className={noHeaderBottomMargin ? "no-bottom-margin" : ""}>
                <div className="showonmobile">
                  <div className="departure-info__essentials__top__content">
                    <div className="grid">
                      <div className="grid-item col--12 col-sm--6">
                        <div className="grid">
                          <div className="departure-info__essentials__top__left">
                            <h6 className="js--marquee">
                              <span className="js--marquee-inner">
                                {flightInfo.CarrierNameMobile} - {flightInfo.Flight}
                              </span>
                            </h6>
                            <h3>
                              {time}
                              {estimatedPublicTime.toMillis() !== scheduledTime.toMillis() ? (
                                <React.Fragment>
                                  <span className={"scheduled-time"}>{scheduledTime.toFormat("HH:mm")}</span>&ensp;
                                </React.Fragment>
                              ) : (
                                ""
                              )}
                              {estimatedPublicTime.toFormat("HH:mm")}
                            </h3>
                          </div>
                          <div className="departure-info__essentials__top__right">
                            <h6>{estimatedPublicTime.toFormat("yyyy")}</h6>
                            <h3>{estimatedPublicTime.toFormat("dd. LLL")}</h3>
                          </div>
                        </div>
                      </div>
                      <div className="grid-item col--12 col-sm--6">
                        <div className="grid">
                          <div className="grid-item col--6">
                            <h6 data-epi-property-name="TerminalLabel">{terminalLabel}</h6>
                            <h3>{flightInfo.CheckInTerminal || currentPage.terminalFallbackValue}</h3>
                          </div>
                          <div className="grid-item col--6">
                            <h6 data-epi-property-name="GateLabel">{gateLabel}</h6>
                            <h3>{flightInfo.Gate || currentPage.gateFallbackValue}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="follow-flight__container__mobile">
                      <div className="follow-flight__switch__label">{currentPage.followFlightLabelTopComponent || "Følg fly"}</div>
                      <label
                        htmlFor="followFlight"
                        className="follow-flight__switch"
                        onClick={
                          !followFlight
                            ? () => trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", flightInfo.FlightId)
                            : undefined
                        }
                      >
                        <input type="checkbox" defaultChecked={followFlight} />
                        <span
                          className={`follow-flight__switch__slider followFlightReact ${followFlight ? "on" : "off"}`}
                          data-enable-follow-flight={enableFollowFlight}
                        ></span>
                      </label>
                      <div className="follow-flight__signup">{flightinformationSignupLink}</div>
                    </div>
                    <div className="flight-info-update">
                      <span className="label">{`${updatedLabel || "Opdateret:"} `}</span>
                      <span className="time">{updatedTimeFormatted}</span>
                    </div>
                  </div>
                </div>
                <div className="showondesktop">
                  <div className="departure-info__essentials__top__content">
                    <div className="departure-info__essentials__top__content__cell">
                      <h6>{flightInfo.Direction === "D" ? currentPage.departureLabel || "Afgang" : currentPage.arrivalLabel || "Ankomst"}</h6>
                      <h3>
                        {time}
                        {estimatedPublicTime.toMillis() !== scheduledTime.toMillis() ? (
                          <React.Fragment>
                            <span className={"scheduled-time"}>{scheduledTime.toFormat("HH:mm")}</span>&ensp;
                          </React.Fragment>
                        ) : (
                          ""
                        )}
                        {estimatedPublicTime.toFormat("HH:mm")}
                      </h3>
                    </div>
                    <div className="departure-info__essentials__top__content__cell">
                      <h6>{currentPage.dateLabel || "Dato"}</h6>
                      <h3>{estimatedPublicTime.toFormat("DD")}</h3>
                    </div>
                    <div className="departure-info__essentials__top__content__cell">
                      <h6 data-epi-property-name="TerminalLabel">{terminalLabel}</h6>
                      <h3>{flightInfo.CheckInTerminal || currentPage.terminalFallbackValue}</h3>
                    </div>
                    <div className="departure-info__essentials__top__content__cell">
                      <h6 data-epi-property-name="GateLabel">{gateLabel}</h6>
                      <h3>{flightInfo.Gate || currentPage.gateFallbackValue}</h3>
                    </div>
                    <div className="departure-info__essentials__top__content__cell">
                      <a
                        className="pointer"
                        onClick={() => {
                          showSignupModal("toggle")
                          trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", flightInfo.FlightId)
                        }}
                      >
                        <h6>{currentPage.followFlightLabelTopComponent || "Følg fly"}</h6>
                        <div className="follow-flight__text" dangerouslySetInnerHTML={{ __html: currentPage.getUpdatesLabel }}></div>
                      </a>
                      <label
                        htmlFor="followFlight"
                        className="follow-flight__switch"
                        onClick={
                          !followFlight
                            ? () => trackTravelPlanner("track-event.generic", "follow flight - click", "toggle - content", flightInfo.FlightId)
                            : undefined
                        }
                      >
                        <input type="checkbox" defaultChecked={followFlight} />
                        <span
                          className={`follow-flight__switch__slider followFlightReact ${followFlight ? "on" : "off"}`}
                          data-enable-follow-flight={enableFollowFlight}
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
              </header>
            </div>
            {flightInfo.Direction === "D"
              ? renderFlightInfoBottomBlock(currentPage.flightInfoBottomBlockContentAreaDeparture)
              : renderFlightInfoBottomBlock(currentPage.flightInfoBottomBlockContentAreaArrival)}
            <div>
              {flightInfo.Direction === "D"
                ? renderItineraryInfoBlocks(currentPage.itineraryInfoContentAreaDeparture)
                : renderItineraryInfoBlocks(currentPage.itineraryInfoContentAreaArrival)}
            </div>

            <React.Fragment>
              {(inactiveSteps && inactiveSteps.length > 0) || (activeSteps && activeSteps.length > 0) ? (
                (tabTwoActiveSteps && tabTwoActiveSteps.length > 0) || (tabTwoInactiveSteps && tabTwoInactiveSteps.length > 0) ? (
                  <div className="tab-panes__navigation__primary">
                    <div className="tab-panes__navigation__primary__inner w--normal">
                      <a className={`button ${tabToggle === tabOne ? "is-active" : ""}`} onClick={() => tabToggleHandler(tabOne)}>
                        <span className="text">{tabOneLabel}</span>
                      </a>
                      <a className={`button ${tabToggle === tabTwo ? "is-active" : ""}`} onClick={() => tabToggleHandler(tabTwo)}>
                        <span className="text">{tabTwoLabel}</span>
                      </a>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {flightInfo.Direction === "D"
                ? renderItineraryInfoBlocks(currentPage.itineraryTravelInformationContentAreaDeparture)
                : renderItineraryInfoBlocks(currentPage.itineraryTravelInformationContentAreaArrival)}
              {(inactiveSteps && inactiveSteps.length > 0) || (activeSteps && activeSteps.length > 0) ? (
                <div className="departure-info__essentials__detailitems">
                  <div className={"foldable"}>
                    {inactiveSteps && inactiveSteps.length > 0 ? (
                      <React.Fragment>
                        <h5
                          className={earlierStepsOpen ? "hide-previous-steps" : "show-previous-steps"}
                          onClick={(e) => showHideContent(e, ".contentWrapper", true)}
                        >
                          {earlierStepsOpen
                            ? currentPage?.hideEarlierStepsLabel || "Skjul tidligere trin"
                            : currentPage?.showEarlierStepsLabel || "Vis tidligere trin"}
                          <span className="arrow"></span>
                        </h5>
                        <div id="inactive-steps" className={`contentWrapper show-hide ${activeSteps.length === 0 ? "no-active-steps" : ""}`}>
                          {inactiveSteps}
                        </div>
                      </React.Fragment>
                    ) : (
                      ""
                    )}
                    {activeSteps && activeSteps.length > 0 ? (
                      <div
                        className={`${activeSteps.length > 0 ? "departure-info__essentials__detailitems__active" : ""} ${
                          !(inactiveSteps && inactiveSteps.length > 0) ? "no-inactive-steps" : ""
                        }`}
                      >
                        {activeSteps}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
            </React.Fragment>
          </div>
        </div>
      </div>
      {flightSignUpModalOpen && (
        <FlightSignupModal
          {...{
            textKeys: currentPage,
            flightInfo: flightInfo,
            profile: profile,
            travelType: tabToggle,
            travelInformation: travelInformation,
            source: "itinerary",
            language: flightInfo.language,
            marketingConsent: marketingConsent,
            trackingEventLabel: trackingEventLabel,
          }}
        />
      )}
    </React.Fragment>
  )
}
